<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Media</h1>
          <div class="button-list has-text-left">
            <b-button
              type="is-primary"
              :disabled="loading"
              :class="{ 'is-loading': loading }"
              @click="exportCatchupSchedule"
            >
              Export Catchup Schedule</b-button
            >

            <b-button
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-10"
              :class="{ 'is-loading': loading }"
              :to="{ name: 'ImportMediaFile' }"
              tag="router-link"
            >
              Import By File</b-button
            >

            <b-button
              v-if="anySelected"
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-10"
              :class="{ 'is-loading': loading }"
              @click="deleteTitles"
            >
              Delete</b-button
            >
          </div>
          <b-field label="Filter by Channel">
            <BaseSelect v-model="channelFilter">
              <option value="">None</option>
              <option v-for="channel in channels">{{ channel }}</option>
            </BaseSelect>
          </b-field>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredMedia"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="selected" label="" width="40">
                <b-checkbox v-model="props.row.selected" />
              </b-table-column>
              <b-table-column
                field="mediadata.titleImage"
                label="Image"
                width="40"
              >
                <img
                  v-if="props.row.mediadata && props.row.mediadata.titleImage"
                  :src="props.row.mediadata.titleImage"
                  style="max-width: 40px"
                />
              </b-table-column>

              <b-table-column field="title" label="Title">
                <router-link
                  :to="{ name: 'EditMedia', params: { id: props.row.id } }"
                  >{{ props.row.title }}
                  {{
                    props.row.mediadata.seriesNo
                      ? 'S' + props.row.mediadata.seriesNo
                      : ''
                  }}</router-link
                >
              </b-table-column>

              <!-- <b-table-column field="media_type" label="Type">
                {{ props.row.media_type === 'movie' ? 'Movie' : 'Series' }}
              </b-table-column> -->
              <b-table-column
                field="mediadata.ageRestriction"
                label="PG Rating"
              >
                {{ props.row.mediadata.ageRestriction }}
              </b-table-column>
              <b-table-column field="mediadata.mediaLength" label="Duration">
                {{ props.row.mediadata.mediaLength }}
              </b-table-column>
              <b-table-column field="metadata.types" label="Content Types">
                {{
                  props.row.metadata && props.row.metadata.types
                    ? props.row.metadata.types.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="metadata.genres" label="Genres">
                {{
                  props.row.metadata && props.row.metadata.genres
                    ? props.row.metadata.genres.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="metadata.countries" label="Countries">
                {{
                  props.row.metadata && props.row.metadata.countries
                    ? props.row.metadata.countries.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="metadata.hashtags" label="Hashtags">
                {{
                  props.row.metadata && props.row.metadata.hashtags
                    ? props.row.metadata.hashtags.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="mediadata.tagline" label="Tagline">
                {{
                  props.row.mediadata && props.row.mediadata.tagline
                    ? props.row.mediadata.tagline
                    : ''
                }}
              </b-table-column>
              <b-table-column field="metadata.suppliers" label="Suppliers">
                {{
                  props.row.metadata && props.row.metadata.suppliers
                    ? props.row.metadata.suppliers.join(', ')
                    : ''
                }}
              </b-table-column>
              <b-table-column field="description" label="Synopsis">
                {{ props.row.description }}
              </b-table-column>
              <b-table-column
                v-if="props.row.media_type === 'movie'"
                field="qcstatus"
                label="Auto QC"
              >
                {{ (props.row.qcstatus || 'Not Available') | capitalize }}
                <a
                  v-if="props.row.qcstatus && props.row.qcstatus === 'failed'"
                  href=""
                  @click.prevent="showQcJobResult(props.row)"
                  >View Errors</a
                >
              </b-table-column>
              <!-- <b-table-column field="manualqcstatus" label="Manual QC">
                <a href="" @click.prevent="changeManualStatus(props.row)">{{
                  (props.row.manualqcstatus || 'Not Available') | capitalize
                }}</a>
              </b-table-column> -->
              <b-table-column
                v-if="props.row.media_type === 'movie'"
                label="File Name For Upload"
              >
                <p>
                  {{ `${props.row.id}_${props.row.title}` }}
                </p>
              </b-table-column>

              <!-- <b-table-column field="user" label="Rights Owner" width="250px">
                {{ props.row.mediadata.rightsOwner }}
              </b-table-column>

              <b-table-column field="user" label="Captured By" width="250px">
                {{ props.row.first_name }}
                {{ props.row.last_name }}
              </b-table-column>

              <b-table-column field="published" label="Published">
                {{ isPublished(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="publish(props.row)">
                  <b-icon
                    v-if="isPublished(props.row)"
                    icon="toggle-switch"
                  ></b-icon>
                  <b-icon
                    v-if="!isPublished(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column>

              <b-table-column field="featured" label="Featured">
                {{ isFeatured(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="markAsFeatured(props.row)">
                  <b-icon
                    v-if="isFeatured(props.row)"
                    icon="toggle-switch"
                  ></b-icon>
                  <b-icon
                    v-if="!isFeatured(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column> -->

              <b-table-column label="">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditMedia',
                        params: { id: props.row.id },
                        query: {
                          admin: 1
                        }
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="props.row.media_type === 'series'"
                    aria-role="listitem"
                    :has-link="true"
                    ><router-link
                      :to="{
                        name: 'ManageEpisodes',
                        params: { id: props.row.id }
                      }"
                      >Manage Episodes</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="confirmDelete(props.row)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No media yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this title?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteTitle()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
    <ExportCatchupScheduleModal
      v-if="showExportCatchupScheduleModal"
      :show="showExportCatchupScheduleModal"
      @close-modal="showExportCatchupScheduleModal = false"
    >
    </ExportCatchupScheduleModal>
    <ChangeManualQCStatusModal
      v-if="showChangeManualQCStatusModal"
      :show="showChangeManualQCStatusModal"
      :media="item"
      @close-modal="showChangeManualQCStatusModal = false"
    >
    </ChangeManualQCStatusModal>
    <ViewHybrikJobResultModal
      v-if="showViewHybrikJobResultModal"
      :show="showViewHybrikJobResultModal"
      :job-id="item.job_id"
      @close-modal="showViewHybrikJobResultModal = false"
      @refresh="fetchMedia"
    >
    </ViewHybrikJobResultModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import BaseSelect from '@/components/BaseSelect'
import ExportCatchupScheduleModal from '@/components/ExportCatchupScheduleModal'
import ChangeManualQCStatusModal from '@/components/ChangeManualQCStatusModal'
import ViewHybrikJobResultModal from '@/components/ViewHybrikJobResultModal'
import MediaApi from '@/api/media'
import ChannelApi from '@/api/channels'
import Filters from '@/mixins/filters'
import Utils from '@/mixins/utils'
import HybrikApi from '@/api/hybrik'
export default {
  name: 'ManageMedia',
  components: {
    CardComponent,
    ExportCatchupScheduleModal,
    BaseSelect,
    ChangeManualQCStatusModal,
    ViewHybrikJobResultModal
  },
  mixins: [Filters, Utils],
  metaInfo: {
    title: 'Manage Titles'
  },
  computed: {
    ...mapGetters(['user']),
    anySelected() {
      if (this.filteredMedia && this.filteredMedia.length > 0) {
        return this.filteredMedia.find(item => item.selected)
      }
      return false
    },
    filteredMedia() {
      let media = this.media
      if (this.channelFilter != '') {
        media = media.filter(
          item =>
            (item &&
              item.metadata &&
              item.metadata.channels &&
              item.metadata.channels.includes(this.channelFilter)) ||
            // account for channels that are objects instead of strings
            // TODO: loop through channels in media to accoutn for more than 1 channel
            (item.metadata &&
              item.metadata.channels &&
              item.metadata.channels[0] &&
              item.metadata.channels[0].name === this.channelFilter)
        )
      }

      if (this.search !== '' && this.media.length > 0) {
        let query = this.search.toLowerCase()
        media = media.filter(item => item.title.toLowerCase().includes(query))
      }

      return media
    }
  },
  async created() {
    this.fetchMedia()
    const channels = await ChannelApi.getAll()
    this.channels = channels.map(item => item.name)
  },
  data() {
    return {
      loading: true,
      media: [],
      channels: [],
      search: '',
      showConfirmModal: false,
      item: {},
      channelFilter: '',
      showExportCatchupScheduleModal: false,
      showChangeManualQCStatusModal: false,
      showViewHybrikJobResultModal: false,
      showDetailsModal: false
    }
  },
  methods: {
    ...mapActions(['getUser']),
    showQcJobResult(item) {
      this.item = item
      this.showViewHybrikJobResultModal = true
    },
    changeManualStatus(item) {
      this.item = item
      this.showChangeManualQCStatusModal = true
    },
    deleteTitles() {
      let items = this.filteredMedia.filter(item => item.selected)
      this.$buefy.dialog.confirm({
        message: `Are you sure you want to delete the ${items.length} titles?`,
        onConfirm: async () => {
          this.loading = true
          await MediaApi.removeMultiple(items.map(item => item.id))
          this.$buefy.toast.open({
            message: 'Titles removed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
          this.media = this.media.filter(item => !item.selected)
        }
      })
    },
    exportCatchupSchedule() {
      this.showExportCatchupScheduleModal = true
    },
    publish(item) {
      MediaApi.publish({
        mediaId: item.id,
        published: item.published === 0 ? 1 : 0
      })
        .then(() => {
          let found = this.media.find(mediaItem => mediaItem.id === item.id)
          found.published = item.published === 0 ? 1 : 0
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing media publish status',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    markAsFeatured(item) {
      MediaApi.markAsFeatured({
        mediaId: item.id,
        featured: item.featured === 0 ? 1 : 0
      })
        .then(() => {
          let found = this.media.find(mediaItem => mediaItem.id === item.id)
          found.featured = item.featured === 0 ? 1 : 0
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing media featured status',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    isPublished(item) {
      return item && item.published === 1
    },
    isFeatured(item) {
      return item && item.featured === 1
    },
    confirmDelete(item) {
      this.showConfirmModal = true
      this.item = item
    },
    deleteTitle() {
      MediaApi.remove({
        mediaId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Media deleted successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchMedia()
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    async fetchMedia() {
      this.loading = true
      const jobs = await HybrikApi.getAll()
      MediaApi.getAll().then(media => {
        media.forEach(item => {
          if (item.mediadata && item.mediadata !== '') {
            item.mediadata = JSON.parse(item.mediadata)
          }
          if (item.metadata && item.metadata !== '') {
            item.metadata = JSON.parse(item.metadata)
          }

          // loop through jobs and match on name format
          const matchedJob = jobs.items.find(job =>
            // TODO: use this.generateFileName(item)
            job.name.includes(`${item.id}_${item.title}`)
          )
          if (matchedJob) {
            item.qcstatus = matchedJob.status
            item.job_id = matchedJob.id
          }
          //
        })
        this.media = media
        this.loading = false
      })
    }
  }
}
</script>

<style>
.table th,
.table td {
  font-size: 12px;
}
</style>
